<card-layout
  [title]="item?.title ?? 'Link'"
  [image]="src"
  [link]="_item?.itemRef"
  (clicked)="onClick()"
></card-layout>
